<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>检验项目</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.key" placeholder="输入项目名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button :type="formInline.stype == 0?'primary':'info'" size="small" @click="stype(0)">全部</el-button>
          <el-button :type="formInline.stype == 1?'primary':'info'" size="small" @click="stype(1)">可预约</el-button>
          <el-button :type="formInline.stype == 2?'primary':'info'" size="small" @click="stype(2)">门诊可约</el-button>
          <el-button :type="formInline.stype == 3?'primary':'info'" size="small" @click="stype(3)">住院可约</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" prop="item_name" label="项目名称" width="260">
      </el-table-column>
      <el-table-column align="center" prop="item_type" label="项目类型" width="160">
      </el-table-column>
      <el-table-column align="center" prop="price" label="价 格" width="160">
        <template slot-scope="scope">
          <span style="color: blue;">￥{{scope.row.price}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="dept" label="科 室">
      </el-table-column>
      <el-table-column align="center" prop="mz_on" label="门诊可预约" width="100">
        <template slot-scope="scope">
            <el-switch v-model="scope.row.mz_on" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.row,'mz_on')"
            :active-value="1" :inactive-value="0">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="zy_on" label="住院可预约" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.zy_on" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.row,'zy_on')"
            :active-value="1" :inactive-value="0">
            </el-switch>
          </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import { getTest,setTest } from '../../api/baseset'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: '',
          stype: 0
        },
        //列表数据
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取数据方法
      getdata(parameter) {
        this.loading = true
         getTest(parameter).then(res => {
           this.loading = false
           if (res.code != 0) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {
             this.listData = res.data.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.data.count
           }
         })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      //搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      stype(type) {
        this.formInline.stype = type
        this.getdata(this.formInline)
      },
      editType(row,type) {
        let data = {id:row.item_id,type:type,value:row[type]}
        setTest(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg);
          }
        })
      }

    }
  }
</script>

<style>
  .user-search {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/yuyue/test.vue